/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './portal-loader.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../app/loader/portal-loader.component';
const styles_PortalLoaderComponent:any[] = [i0.styles];
export const RenderType_PortalLoaderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PortalLoaderComponent,data:{}});
function View_PortalLoaderComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),8,'div',[['class',
      'app-loading']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),0,'div',[['class','logo']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(4,0,(null as any),(null as any),3,':svg:svg',[['class','spinner'],
          ['viewBox','25 25 50 50']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n      '])),(_l()(),
          i1.ɵeld(6,0,(null as any),(null as any),0,':svg:circle',[['class','path'],
              ['cx','50'],['cy','50'],['fill','none'],['r','20'],['stroke-miterlimit',
                  '10'],['stroke-width','2']],(null as any),(null as any),(null as any),
              (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(null as any));
}
export function View_PortalLoaderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_PortalLoaderComponent_1)),i1.ɵdid(1,16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i3.PortalLoaderComponent = _v.component;
    const currVal_0:any = _co.loader;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_PortalLoaderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'gosg-portal-loader',
      ([] as any[]),(null as any),(null as any),(null as any),View_PortalLoaderComponent_0,
      RenderType_PortalLoaderComponent)),i1.ɵdid(1,114688,(null as any),0,i3.PortalLoaderComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PortalLoaderComponentNgFactory:i1.ComponentFactory<i3.PortalLoaderComponent> = i1.ɵccf('gosg-portal-loader',
    i3.PortalLoaderComponent,View_PortalLoaderComponent_Host_0,{loader:'loader'},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbG9hZGVyL3BvcnRhbC1sb2FkZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbG9hZGVyL3BvcnRhbC1sb2FkZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vVXNlcnMvc2hhaXphci9Qcm9qZWN0cy9NQU1QVS9NeUdvdi9wb3J0YWwtZmUvc3JjL2FwcC9sb2FkZXIvcG9ydGFsLWxvYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL3NoYWl6YXIvUHJvamVjdHMvTUFNUFUvTXlHb3YvcG9ydGFsLWZlL3NyYy9hcHAvbG9hZGVyL3BvcnRhbC1sb2FkZXIuY29tcG9uZW50LnRzLlBvcnRhbExvYWRlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJhcHAtbG9hZGluZ1wiICpuZ0lmPVwibG9hZGVyXCI+XG4gICAgPGRpdiBjbGFzcz1cImxvZ29cIj48L2Rpdj5cbiAgICA8c3ZnIGNsYXNzPVwic3Bpbm5lclwiIHZpZXdCb3g9XCIyNSAyNSA1MCA1MFwiPlxuICAgICAgPGNpcmNsZSBjbGFzcz1cInBhdGhcIiBjeD1cIjUwXCIgY3k9XCI1MFwiIHI9XCIyMFwiIGZpbGw9XCJub25lXCIgc3Ryb2tlLXdpZHRoPVwiMlwiIHN0cm9rZS1taXRlcmxpbWl0PVwiMTBcIi8+XG4gICAgPC9zdmc+XG4gIDwvZGl2PlxuIiwiPGdvc2ctcG9ydGFsLWxvYWRlcj48L2dvc2ctcG9ydGFsLWxvYWRlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBd0MsOENBQ3BDO1VBQUE7VUFBQSw4QkFBd0I7TUFDeEI7VUFBQTtVQUFBLGdCQUEyQyxnREFDekM7aUJBQUE7Y0FBQTtrQkFBQTtjQUFBLDhCQUFpRztNQUM3Rjs7O29CQUpWO01BQUEsc0NBQUE7b0JBQUEsbUNBS1E7TUFBQTs7SUFMaUI7SUFBekIsV0FBeUIsU0FBekI7Ozs7b0JDQUE7TUFBQTtzQ0FBQSxVQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/loader/portal-loader.component.ngfactory.ts